
<ng-template [ngIf]="authentication">
  <app-menu></app-menu>
</ng-template>
